module.exports = __webpack_public_path__ + "img/doi@3x.88c85d6d.png";